import React from "react";
import { theme } from "antd";

export const AuthHeroIllustration: React.FC = () => {
  const { token } = theme.useToken();
  const { colorPrimary, colorBgContainer } = token;

  return (
    <svg
      viewBox="0 0 800 600"
      preserveAspectRatio="xMidYMid slice"
      width="100%"
      height="100%"
      className="absolute inset-0"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="800" height="600" fill={colorBgContainer} />

      {/* Stacked diagonal parallelograms — same slope, increasing opacity right-to-left */}
      <polygon points="350,0 800,0 800,600 100,600" fill={colorPrimary} fillOpacity={0.08} />
      <polygon points="490,0 800,0 800,600 240,600" fill={colorPrimary} fillOpacity={0.12} />
      <polygon points="610,0 800,0 800,600 360,600" fill={colorPrimary} fillOpacity={0.18} />
      <polygon points="710,0 800,0 800,600 460,600" fill={colorPrimary} fillOpacity={0.25} />
      <polygon points="770,0 800,0 800,600 580,600" fill={colorPrimary} fillOpacity={0.30} />
      <polygon points="770,0 200,0 800,600 580,600" fill={colorPrimary} fillOpacity={0.40} />

      {/* Bright corner accent triangle */}
      <polygon points="720,0 800,0 800,80" fill={colorPrimary} fillOpacity={0.90} />
    </svg>
  );
};
